import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, type RefObject } from 'react';
import { type Slot, type AdvertisersConfigGeneric, VideoAdv } from '@sbt-web/adv';
import { LiraContainerIds } from '@/client/components/Adv/Lira/liraContainerIds';
import style from './LazyVideoPreroll.module.scss';

/**
 * Exported only to use it in unit test
 */
export const getVideoUrl = (adUnitPath: string, sizes: googletag.MultiSize): string => {
  const adUnitNormalized = {
    bids: [],
    code: adUnitPath,
    id: LiraContainerIds.adView.videoPreroll,
    mediaTypes: {},
    sizes
  };

  // Generate targetings from GPT ad object
  const pubAds = window.googletag?.pubads();
  const targeting = pubAds.getTargetingKeys().reduce((acc: Record<string, string>, key: string) => {
    const targeting = pubAds.getTargeting(key);
    acc[key] = targeting[0];
    return acc;
  }, {});
  const correlator = Math.floor(Math.random() * 10000000000).toString(); // NOSONAR
  return window.pbjs?.adServers.dfp.buildVideoUrl({
    adUnit: adUnitNormalized,
    params: {
      iu: adUnitNormalized.code,
      env: 'vp',
      gdfp_req: '1',
      sz: '624x468',
      unviewed_position_start: '1',
      tfcd: '0',
      npa: '0',
      impl: 's',
      correlator,
      output: 'vast',
      cust_params: targeting
    }
  });
};
export const LazyVideoPreroll = function (t0) {
  const $ = _c(8);
  const {
    parentRef
  } = t0;
  const [video, setVideo] = useState(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      window.liraSDKQueue?.push(() => {
        window.liraSdk.fetchLazyLoadAd([LiraContainerIds.adView.videoPreroll]).then(map => {
          const slot = map.get(LiraContainerIds.adView.videoPreroll);
          if (!slot) {
            return;
          }
          const config = slot.primaryAdvertiserConfig as AdvertisersConfigGeneric<'gam'>;
          const adUnit = config.config.adUnitCode;
          const sizes = config.config.sizes;
          const videoUrl = getVideoUrl(adUnit, sizes);
          setVideo(videoUrl);
        });
      });
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div id={LiraContainerIds.adView.videoPreroll} className={style.videoId} />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== parentRef || $[4] !== video) {
    t4 = video ? <VideoAdv parentRef={parentRef as RefObject<HTMLElement>} videoUrl={video} /> : null;
    $[3] = parentRef;
    $[4] = video;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};